module.exports = __webpack_public_path__ + "static/media/payday-loan.1852e794.svg";